// trader_agent_frontend/src/utils/apiClient.js
import axios from 'axios';
import { getAuth } from '../firebase';  

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_TRADER_BASE_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach Firebase token
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();  // <-- This now works
      const user = auth.currentUser;
      
      if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
        console.debug('Added auth token to request');
      }
    } catch (error) {
      console.warn('Failed to get auth token:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Keep your existing response interceptor
apiClient.interceptors.response.use(
  (response) => {
    const rateLimit = response.headers['x-ratelimit-remaining'];
    const aiStatus = response.headers['x-ai-status'];
    
    if (rateLimit !== undefined) {
      console.log(`AI requests remaining: ${rateLimit}`);
    }
    
    return response;
  },
  (error) => {
    if (error.response?.status === 429) {
      const retryAfter = error.response.headers['retry-after'];
      console.warn(`AI rate limited. Retry after: ${retryAfter} seconds`);
    }
    
    if (error.response?.status === 401) {
      console.error('Authentication failed. User may need to re-login.');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;